import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'
import { Button } from 'react-bootstrap'
import GeneralInfoWithThumbnail from '../../../components/GeneralInfoWithThumbnail'
import getMugshotSrc from '../../../utils/getMugshotSrc'
import openBusinessCard from '../../profile/openBusinessCard'
import { User } from '../../auth/types'
import { VirtualAttendee } from '../../../types/swagger'
import { currentUserSelector } from '../../auth/authSlice'
import Icon from '../../../components/Icon'
import sendToUser from '../../websocket/sendToUser'
import { addModal } from '../../modals/modalSlice'
import { _ } from '../../../utils/localization'
import { formatJobInfo, formatName } from '../../../utils/profile'

const S = {
    // copied from CustomPopover
    ActionWrapper: styled.div`
        display: flex;
        justify-content: flex-end;
        margin-top: 10px;
    `,
}

const KickUserModal = ({ attendee, close } : {attendee: VirtualAttendee, close: () => void}) => {
    const dispatch = useDispatch()

    const kickUser = () => {
        dispatch(sendToUser({
            receiverId: attendee.id,
            event: 'kicked_from_videocall',
        }))
        close()
    }

    return (
        <div>
            <GeneralInfoWithThumbnail
                image={getMugshotSrc(attendee)}
                name={formatName(attendee)}
                description={formatJobInfo(attendee)}
                noBorder
            />
            <S.ActionWrapper>
                <Button
                    variant="danger"
                    onClick={() => close()}
                >
                    {_('meeting.kick_user.cancel_button')}
                </Button>
                {' '}
                <Button
                    variant="success"
                    onClick={() => kickUser()}
                >
                    {_('meeting.kick_user.confirm_button')}
                </Button>
            </S.ActionWrapper>
        </div>
    )
}

const AttendeeList = ({ attendees, currentUserIsAdmin = false }
: { attendees: VirtualAttendee[], currentUserIsAdmin?: boolean }) => {
    const dispatch = useDispatch()
    const currentUser = useSelector(currentUserSelector())

    const openKickModal = (attendee: VirtualAttendee) => {
        const component = ({ close }: { close: () => void }) => (
            <KickUserModal attendee={attendee} close={close} />
        )

        dispatch(addModal({
            Component: component,
            size: 'sm',
            header: _('meeting.kick_user.modal_header'),
        }))
    }

    return (
        <div style={{ padding: '0 8px' }}>
            {
                attendees.map((attendee) => (
                    <GeneralInfoWithThumbnail
                        key={attendee.id}
                        image={getMugshotSrc(attendee)}
                        onClick={() => dispatch(openBusinessCard(attendee as User))}
                        name={formatName(attendee)}
                        description={formatJobInfo(attendee)}
                        noBorder
                        size="sm"
                    >
                        {currentUserIsAdmin
                        && currentUser.id !== attendee.id
                        && <Icon icon="delete" onClick={() => openKickModal(attendee)} />}
                    </GeneralInfoWithThumbnail>
                ))
            }
        </div>
    )
}

export default AttendeeList
